import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";

const FilteringComponent = ({
    t,
    owners,
    statuses,
    priorities,
    onChange
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        status: null,
        priority: null,
        owner: null
    });

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'status',
                title: 'Task Status',
                icon: <i className="ri-checkbox-circle-line" />,
                isLoading: false,
                defaultValue: tableFilters?.status,
                data: (statuses || []).map((item) => ({
                    ...item,
                    id: item.value
                })),
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return t(item.label) 
                }
            },
            {
                type: 'radio_list',
                name: 'priority',
                title: 'Priority',
                icon: <i className="ri-arrow-up-down-fill" />,
                isLoading: false,
                defaultValue: tableFilters?.priority,
                data: (priorities || []).map((item) => ({
                    ...item,
                    id: item.value
                })),
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return t(item.baseLabel) 
                }
            },
            {
                type: 'radio_list',
                name: 'owner',
                title: 'Owner',
                icon: <i className="ri-user-line" />,
                isLoading: owners.isLoading,
                defaultValue: tableFilters?.owner,
                data: owners.data || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return `${item.first_name} ${item.last_name}`
                }
            }
        ]
    }, [
        tableFilters,
        owners,
        priorities,
        statuses,
        t
    ]);

    const onTableFilterOkButtonClicked = (filters) => {
        if (filters) {
            const result = {}
            if ('status' in filters) {
                result.status = filters.status !== 'all' ? filters.status : undefined
            }

            if ('owner' in filters) {
                result.owner = filters.owner !== 'all' ? filters.owner : undefined
            }

            if ('priority' in filters) {
                result.priority = filters.priority !== 'all' ? filters.priority : undefined
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                status: null,
                owner: null,
                priority: null
            })
        }
    }

    useEffect(() => {
        onChange && onChange(tableFilters)
    }, [ tableFilters ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='status'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);